import { yupResolver } from "@hookform/resolvers/yup";
import {
  toastrErrorAlert,
  toastrSuccessAlert,
} from "components/Common/AlertToastr";
import { CommonButton } from "components/Common/ButtonCommon";
import HeaderCreateItem from "components/Common/HeaderCreateItem";
import VVSTable from "components/form-control/VVSTable";
import useGetFormSchema from "custom-hook/useGetFormSchema";
import { GET_PRODUCT } from "helpers/url_helper";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory, useParams } from "react-router-dom";
import { Container } from "reactstrap";
import httpService from "services/httpService";
import * as yup from "yup";

export default function NewProduct() {
  const { id } = useParams();
  const history = useHistory();
  const [productDetail, setProductDetail] = useState({});

  const schema = yup
    .object({
      order: yup.string().required("Vui lòng nhập số thứ tự hiển thị!"),
      name: yup.string().required("Vui lòng nhập tên!"),
      templateType: yup
        .string()
        .required("Vui lòng chọn hiển thị template theo chiều!"),
    })
    .required();

  useEffect(() => {
    getPHLProductDetail();
  }, [id]);

  const {
    handleSubmit,
    formState: { errors },
    ...rest
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(schema),
  });

  const { renderForm } = useGetFormSchema("Product", yup, rest, errors);

  const getPHLProductDetail = async () => {
    if (!id) return;

    const res = await httpService.get(`${GET_PRODUCT}/${id}`);

    console.log("res", res);

    if (!res) {
      history.replace("/product");
      toastrErrorAlert("Product not found!");
      return;
    }
    const { reset } = rest;

    reset({
      ...res,
    });
    setProductDetail(res);
  };

  const onSubmit = async values => {
    const { createdAt, updatedAt, ...rest } = values;

    const body = {
      ...rest,
      order: Number(values.order),
      templateType: Number(values.templateType),
    };
    if (id) {
      await httpService.put(`${GET_PRODUCT}/${id}`, body);
      toastrSuccessAlert("Cập nhật sản phẩm phl thành công!");
      return;
    }

    const res = await httpService.post(`${GET_PRODUCT}`, body);

    toastrSuccessAlert("Thêm sản phẩm phl thành công!");
    history.replace(`/product/${res.objectId}`);
  };

  return (
    <div className="page-content">
      <form onSubmit={handleSubmit(onSubmit)}>
        <HeaderCreateItem title={"Sản phẩm PHL"}>
          <CommonButton level={0} type="submit">
            Save
          </CommonButton>
        </HeaderCreateItem>
        <Container fluid>
          {renderForm([])}
          <VVSTable
            title="Chi tiết sản phẩm"
            name="ProductContent"
            whereQuery={{
              product: {
                __type: "Pointer",
                className: "Product",
                objectId: id,
              },
            }}
            routingPath="/product-content/new-product-content"
            dataTransfer={{
              productId: id,
              productName: productDetail?.name,
            }}
          />
        </Container>
      </form>
    </div>
  );
}
